<template>
  <v-main style="padding: 0">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('common.search')"
      single-line
      hide-details
      style="margin: 0rem 2rem"
    ></v-text-field>

    <v-data-table
      :headers="headers"
      :items="devices"
      :loading="status.loading"
      :items-per-page="50"
      class="elevation-1"
      @click:row="clickedRow"
      :search="search"
      sort-by="lastContact"
      :sort-desc="true"
    >
      <template v-slot:[`item.lastContact`]="{ item }">
        {{ humanDate(item.lastContact) }}
      </template>
    </v-data-table>
  </v-main>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { format } from "date-fns";

export default {
  name: "ListDevice",

  data() {
    return {
      search: "",
      headers: [
        { text: this.$t("device.serialNumber"), value: "serialNumber" },
        { text: this.$t("device.imei"), value: "imei" },
        { text: this.$t("device.productName"), value: "productName" },
        { text: this.$t("device.metas"), value: "meta" },
        { text: this.$t("device.lastContact"), value: "lastContact" },
        { text: "", value: "actions" },
      ],
    };
  },

  computed: {
    ...mapState("devices", { devices: "devices", status: "status" }),
  },

  methods: {
    ...mapActions("devices", ["get"]),

    gatherMeta(device) {
      let result = "";
      for (let d in device.deviceMetas) {
        result += `${device.deviceMetas[d].keyName}: ${device.deviceMetas[d].value}`;
      }

      return result;
    },

    humanDate(date) {
      return date !== undefined
        ? format(new Date(date), "dd MMM - HH:mm")
        : "N/A";
    },

    clickedRow(item) {
      this.$router.push(`/device/detail/${item.deviceId}`);
    },

    getColorFromBool(val) {
      return val ? "success" : "error";
    },
  },

  async created() {
    await this.get(true);
  },
};
</script>
